import { Discord, Github } from '@boxicons/react';
import { ConnectableApp } from '@gdladder/shared/enums';

export function AppToIcon({ app }: { app: ConnectableApp }) {
    switch (app) {
        case ConnectableApp.AREDL:
            return <img src='https://aredl.net/favicon.ico' width={48} height={48} className='rounded-full' />;
        case ConnectableApp.DISCORD:
            return <Discord size='lg' />;
        case ConnectableApp.GITHUB:
            return <Github size='lg' />;
    }
}
